export const SECTION_HEADING_DIV: React.CSSProperties = {
  paddingBottom: '30px',
}
